import util from '@bmp-vue/core/api/util'
const controller = 'PagadorEletronico'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  Obter: function (dto) {
    return util.Axios.GetAll(controller, dto)
  },
  ObterBoletos: function (dto) {
    return util.Axios.GetAll(controller + '/Boletos', dto)
  },
  ExcluirBoleto: function (codigoConta, codigoBoleto) {
    return util.Axios.Delete(controller + '/Boleto/' + codigoConta, codigoBoleto)
  },
  Aderir: function (dto) {
    return util.Axios.Post(controller, dto)
  },
  CancelarAdesao: function (codigoConta) {
    return util.Axios.Delete(controller, codigoConta)
  }
})
